
<div class="row top-content-border" [ngStyle]="{'height.px': workspaceHeight}" style="margin-left:30px;margin-right:30px ;">
   <div class="black-workspace col-md-12" style="padding: 10px">
      <callsmart-company-list class="black-datatable no-horizontal-scrollbar top-content-border"
      (createCompany) = "onCreateCompany()"
      [scrollHeight]="scrollHeight"></callsmart-company-list>
   </div>
</div>

<div class="row">

   <hr style="margin-left:30px;margin-right:30px ;">
   <div style="float:right; margin-left:30px;margin-right:30px ; ">
      <button type="button" class="btn cs-btn-secondary-inverse" (click)="onDeleteCompany()"  [disabled]="companyList.selectedCompanies == null">
            <i class="cs-icon icon-trash" style="font-size: 15px"></i> Delete</button>

      <button type="button" class="btn cs-btn-primary-inverse" (click)="onEditCompany()" [disabled]="companyList.selectedCompanies == null" >Edit</button>
   </div>
</div>


<ndc-dynamic *ngIf="showDeleteCompanyDialog" [ndcDynamicComponent]="deleteCompanyDialog" [ndcDynamicInputs]="dialogInput"
   [ndcDynamicOutputs]="dialogOutput">
</ndc-dynamic>

<ndc-dynamic *ngIf="showAddEditCompanyDialog" [ndcDynamicComponent]="addEditCompanyDialog" [ndcDynamicInputs]="addEditDialogInput"
   [ndcDynamicOutputs]="addEditDialogOutput">
</ndc-dynamic>
